import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import companyLocationActions from '../actions/companyLocation';

function getLocationMetadata(store) {
    request.get(`/${config.url_prefix}/api/addressMetadata?site=${store.getState().system.siteName}`)
        .end((error, response) => {
            if (error) {
                const errorKey = 'ipmob.internal.server.error';
                store.dispatch(companyLocationActions.alertError(errorKey));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (!parsedResponse || parsedResponse.statusCode >= 400 || parsedResponse.code >= 400) {
                        store.dispatch(companyLocationActions.alertError('ipmob.error.process.request'));
                    } else {
                        store.dispatch(companyLocationActions.getLocationMetadataSuccess(parsedResponse));
                        if(store.getState().billingSetup?.isBillingSetupFlow) {
                            const userMeta = store.getState().billingSetup?.userMeta;
                            const vatMeta = store.getState().billingSetup?.vatMeta;
                            store.dispatch(companyLocationActions.prePopulateFromBillingSetupMetadata(userMeta, vatMeta));
                        }
                    }
                } catch (exp) {
                    store.dispatch(companyLocationActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getLocationMetadata;
